import classNames from 'classnames';
import * as React from 'react';

const BaseField = function(props) {
  const {
          autoComplete,
          checked,
          className,
          defaultValue,
          disabled,
          input,
          meta,
          placeholder,
          required,
          style,
          type,
        } = props;

  const [hide, setHide] = React.useState(false);

  const hideTemporaryCaret = React.useCallback(() => {
    setHide(true);

    setTimeout(() => {
      setHide(false);
    }, 5);
  }, []);
  const setDefaultValue = React.useCallback(() => {
    if (!meta.touched && defaultValue && defaultValue !== input.value) {
      input.onChange(defaultValue);
    }
  }, [defaultValue, input.value, meta.touched]);

  React.useEffect(() => {
    setDefaultValue();
  }, [defaultValue, meta.touched, input.value]);

  return (
    <input
      {...input}
      autoComplete={autoComplete}
      checked={checked || input.value}
      className={classNames(className, { error: meta.touched && meta.error })}
      disabled={disabled}
      onChange={(...args) => {
        hideTemporaryCaret();
        input.onChange(...args);
      }}
      placeholder={placeholder ? `${placeholder} ${required ? '*' : ''}` : ''}
      style={{
        ...style,
        caretColor: hide ? '#ffffff' : '#000000',
      }}
      type={type}
    />
  );
};

BaseField.defaultProps = {
  type:         'text',
  autoComplete: 'on',
};

export default BaseField;